import React from "react";
import { Navigate, Route, Routes } from "react-router-dom";

/**
 * News Routes and Pages
 */
const ListGeneralsettingPage = React.lazy(() => import("./ListGeneralsettingPage"));


const GeneralsettingRoutes = () => {
  return (
    <Routes>
      <Route index exact path="/list" element={<ListGeneralsettingPage />} />
      
      <Route path="*" element={<Navigate replace to="/404" />} />
    </Routes>
  );
};

export default GeneralsettingRoutes;
